const IMAGES = {
  logo: require("./logo.png"),
  email: require("./email.svg").default,
  green_check: require("./green_check.svg").default, // Remember to use .default with SVG images
  user: require("./user.svg").default, // Remember to use .default with SVG images
};

export default IMAGES;
